// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"ProductSizesList_contentComponent__1px4y","tableContainer":"ProductSizesList_tableContainer__1v5p-"};